<template>
  <div>
    <p class="process-repair-tab-section-title">
      {{$t(title)}}
    </p>
    <v-row
    class="pa-2">
      <v-col
      cols="6">
        <p class="process-repair-tab-section-title text-subtitle-1">
          {{$t("pages.part.predefinedServices.allAvailable")}}
        </p>
        <div
        class="predefined-services-list rounded-lg elevation-2 pa-2">
          <infinite-loader
          v-if="loading"
          color="#007bff"
          size="30"/>
          <div
          v-else>
            <div
            v-for="(p, i) in getFilteredAvailable"
            :key="i"
            class="available-service mb-2 elevation-4 d-flex justify-center pa-1"
            @click="add(p)"
            :disabled="loading">
              <span>
                {{p.text}}
              </span>
            </div>
          </div>
        </div>
      </v-col>
      <v-col
      cols="6">
        <p class="process-repair-tab-section-title text-subtitle-1">
          {{$t("pages.part.predefinedServices.appliedToCurrentPart")}}
        </p>
        <div
        class="predefined-services-list rounded-lg elevation-2 pa-2">
          <infinite-loader
          v-if="loading"
          color="#007bff"
          size="30"/>
          <div
          v-else>
            <div
            v-for="({text}, i) in model"
            :key="i"
            class="d-flex align-center justify-space-between">
              <span
              class="mb-2"
              style="color: #007bff">
                <em>{{text}}</em>
              </span>
              <icon-button
              @click="remove(i)"
              src="minus"
              color="red"/>
            </div>
          </div>
        </div>
      </v-col>
    </v-row>
    <hr
    v-if="showFooterLine"
    style="width: 100%; height: 5px; background: #33b5e5;"
    class="my-3 rounded-xl"/>
  </div>
</template>

<script>
import IconButton from '@/components/btns/IconButton'
import InfiniteLoader from '@/components/common/InfiniteLoader'

export default {
  components: {
    IconButton,
    InfiniteLoader
  },
  props: {
    value: {
      type: Array,
      default: () => []
    },
    allAvailable: {
      type: Array,
      default: () => []
    },
    title: {
      type: String,
      default: ""
    },
    loading: {
      type: Boolean,
      default: false
    },
    showFooterLine: {
      type: Boolean,
      default: true
    }
  },
  model: {
    prop: "value",
    event: "valueChanged"
  },
  computed: {
    model: {
      get: function() {
        return this.$props.value
      },
      set: function(v) {
        this.$emit("valueChanged", v)
      }
    },
    getFilteredAvailable() {
      const currentlyApplied = this.model.map(o => o.value)
      return this.allAvailable.filter(o => !currentlyApplied.includes(o.value))
    }
  },
  methods: {
    add(o) {
      this.model.push(o)
    },
    remove(i) {
      this.model.splice(i, 1)
    }
  }
}
</script>

<style>
.available-service {
  background: #4285f4;
  color: white;
  cursor: pointer;
  user-select: none;
}
</style>